import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Managed, { useManaged } from "../common/components/Managed";
import StaticTable from "../common/components/StaticTable";
import api from "../common/lib/api";
import { UPGRADE_FIELDS } from "./Manage/CompanyPage";

export default function Page() {
  const { saleOrderId } = useParams();
  const [state, setState, setError] = useManaged();

  const { data } = state;

  async function load(saleOrderId, setState, setError) {
    try {
      const { data } = await api.get(
        "/sale-orders/item/" + saleOrderId + "/upgrades"
      );
      setState(data.data);
    } catch (e) {
      setError(e);
    }
  }

  useEffect(() => {
    load(saleOrderId, setState, setError);
  }, [saleOrderId, setError, setState]);

  return (
    <>
      <Managed state={state}>
        {data && (
          <>
            <StaticTable items={data || []} fields={UPGRADE_FIELDS} />
          </>
        )}
      </Managed>
    </>
  );
}
